export type Role =
  | 'PSM' // Parts Manager
  | 'FOM' // Fixed Ops Manager
  | 'DGM' // Digital Manager
  | 'SAM' // Sales Manager
  | 'UVM' // Used Vehicle Manager
  | 'GNM' // General Manager
  | 'DLR' // Dealer
  | 'SRM' // Service Manager
  | 'STAFF' // Staff
  | 'BDM' //  Manager
  | 'OFM' // Office Manager
  | 'NVM' // New Vehicle Manager
  | 'VCP' // Vice President
  | 'CONSULT'; // Consultant

export type DepartmentMenu =
  | 'Total Dealership'
  | 'Balance Sheet'
  | 'Variable Ops'
  | 'New Vehicle'
  | 'Used Vehicle'
  | 'F&I'
  | 'Fixed Ops'
  | 'Service'
  | 'Parts & Accessories'
  | 'Body Shop'
  | 'Employee Productivity'
  | 'All Expenses'
  | 'Collision Center';

export const roleAccessMap: Record<
  Role,
  Partial<Record<DepartmentMenu, boolean>>
> = {
  FOM: {
    'All Expenses': true,
    'Total Dealership': true,
    'Balance Sheet': true,
    'Variable Ops': true,
    'Fixed Ops': true,
    Service: true,
    'Parts & Accessories': true,
    'Body Shop': true,
    'Employee Productivity': true,
  },
  DGM: {
    'Total Dealership': true,
    'Balance Sheet': true,
    'Variable Ops': true,
    'New Vehicle': true,
    'Used Vehicle': true,
    'F&I': true,
    'Fixed Ops': true,
    Service: true,
    'Parts & Accessories': true,
    'Body Shop': true,
    'Employee Productivity': true,
    'All Expenses': true,
  },
  PSM: {
    'All Expenses': true,
    'Total Dealership': true,
    'Balance Sheet': true,
    'Used Vehicle': true,
    Service: true,
    'Parts & Accessories': true,
    'Body Shop': true,
    'Employee Productivity': true,
  },
  SAM: {
    'All Expenses': true,
    'Total Dealership': true,
    'Balance Sheet': true,
    'Variable Ops': true,
    'New Vehicle': true,
    'Used Vehicle': true,
    'F&I': true,
    Service: true,
    'Parts & Accessories': true,
    'Body Shop': true,
    'Employee Productivity': true,
  },
  NVM: {
    'All Expenses': true,
    'Total Dealership': true,
    'Balance Sheet': true,
    'New Vehicle': true,
    'F&I': true,
    Service: true,
    'Parts & Accessories': true,
    'Body Shop': true,
    'Employee Productivity': true,
  },
  VCP: {
    'All Expenses': true,
    'Total Dealership': true,
    'Balance Sheet': true,
    'Variable Ops': true,
    'New Vehicle': true,
    'Used Vehicle': true,
    'F&I': true,
    'Fixed Ops': true,
    Service: true,
    'Parts & Accessories': true,
    'Body Shop': true,
    'Employee Productivity': true,
  },
  UVM: {
    'All Expenses': true,
    'Total Dealership': true,
    'Balance Sheet': true,
    'Variable Ops': true,
    'Used Vehicle': true,
    'F&I': true,
    Service: true,
    'Parts & Accessories': true,
    'Body Shop': true,
    'Employee Productivity': true,
  },
  GNM: {
    'All Expenses': true,
    'Total Dealership': true,
    'Balance Sheet': true,
    'Variable Ops': true,
    'New Vehicle': true,
    'Used Vehicle': true,
    'F&I': true,
    'Fixed Ops': true,
    Service: true,
    'Parts & Accessories': true,
    'Body Shop': true,
    'Employee Productivity': true,
  },
  DLR: {
    'All Expenses': true,
    'Total Dealership': true,
    'Balance Sheet': true,
    'Variable Ops': true,
    'New Vehicle': true,
    'Used Vehicle': true,
    'F&I': true,
    'Fixed Ops': true,
    Service: true,
    'Parts & Accessories': true,
    'Body Shop': true,
    'Employee Productivity': true,
  },
  SRM: {
    'All Expenses': true,
    'Total Dealership': true,
    'Balance Sheet': true,
    'Fixed Ops': true,
    Service: true,
    'Parts & Accessories': true,
    'Body Shop': true,
    'Employee Productivity': true,
  },
  STAFF: {
    'All Expenses': true,
    'Total Dealership': true,
    'Balance Sheet': true,
    'Variable Ops': true,
    'New Vehicle': true,
    'Used Vehicle': true,
    'F&I': true,
    'Fixed Ops': true,
    Service: true,
    'Parts & Accessories': true,
    'Body Shop': true,
    'Employee Productivity': true,
    'Collision Center': true,
  },
  CONSULT: {
    'All Expenses': true,
    'Total Dealership': true,
    'Balance Sheet': true,
    'Variable Ops': true,
    'New Vehicle': true,
    'Used Vehicle': true,
    'F&I': true,
    'Fixed Ops': true,
    Service: true,
    'Parts & Accessories': true,
    'Body Shop': true,
    'Employee Productivity': true,
    'Collision Center': true,
  },
  BDM: {
    'All Expenses': true,
    'Total Dealership': true,
    'Balance Sheet': true,
    'Used Vehicle': true,
    'Fixed Ops': true,
    Service: true,
    'Parts & Accessories': true,
    'Body Shop': true,
    'Employee Productivity': true,
  },
  OFM: {}, // No access
};
